<p-button
  [disabled]="disabled"
  (click)="downloadTemplate()"
  styleClass="p-button-excel"
  [rounded]="true"
  icon="fas fa-file-excel"
  [label]="label"></p-button>
